import React, { useEffect, useRef, useState } from "react";
import axios from 'axios'
import { Editor } from "@tinymce/tinymce-react";
const TinyEditor = ({
  onChange,
  initialValue,
  isError,
  erroMessage,
  height = 500,
  pasteAsText = false,
}) => {
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const [wordCount, setWordCount] = useState(0);

  useEffect(() => {
    onChangeRef.current = onChange;
  });

  const handleChange = (content) => {
    const words = content.trim().split(/\s+/).length;
    setWordCount(words);
    if (typeof onChangeRef.current === "function") {
      onChangeRef.current(content, words);
    }
  };

  // File picker callback function
  const filePickerCallback = (callback, value, meta) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*"); // Specify accepted file types, e.g., images
    input.onchange = function () {
      const file = this.files[0];
      const reader = new FileReader();
      reader.onload = function () {
        // Convert the file to a base64 string
        const base64 = reader.result;
        // Pass the base64 string to the callback function
        callback(base64, {
          text: file.name,
        });
      };
      reader.readAsDataURL(file);
    };
    input.click(); // Trigger the file input dialog
  };

const apiKeys = [ "t71xx03in65yttvd5fujvjaic61e9gruax24c9g6v66w31pm" , "bfrk76i1ue7cnr7zhf5oa08cxxuzy2kpp44yals0fke93e3p"  ]
const [keyIndex, setKeyIndex] = useState(0);
  return (
    <>
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        onLoadError={() => {
        // Fall back to next key if current one fails
        if (keyIndex < apiKeys.length - 1) {
          setKeyIndex(keyIndex + 1);
        }
      }}
         apiKey={apiKeys[keyIndex]}
        init={{
          height,
          menubar: "file edit insert view format table tools help",
          automatic_uploads: true,
          paste_as_text: pasteAsText,
          paste_remove_styles: true,
          paste_remove_styles_if_webkit: true,
          paste_webkit_styles: "none",
          paste_merge_formats: true,
          paste_preprocess: (plugin, args) => {
            if (pasteAsText) return;
            args.content = args.content
              .replace(/<(b|strong)>/gi, "")
              .replace(/<\/(b|strong)>/gi, "")
              .replace(/\sstyle="[^"]*"/gi, "")
              .replace(/\sclass="[^"]*"/gi, "");
          },
images_reuse_filename: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "print",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "paste",
            "code",
            "help",
            "wordcount",
            "imagetools",
          ],
          images_upload_url: "https://api.tetr.com/api/upload/r2", // Replace with your upload endpoint
          images_upload_handler: function  (blobInfo, success, failure) {
            console.log(blobInfo.blob(), "------------------blobobobobo");
            console.log(blobInfo, "------------------blosabobobobo");
            console.log(blobInfo.filename(), "------------------filemanan");
            console.log(blobInfo.name(), "------------------name");
            console.log(blobInfo.id(), "------------------id");
            console.log(blobInfo.blobUri(), "------------------blobUri");
            console.log(blobInfo.uri(), "------------------blobUri");
            const formData = new FormData();
            const lastValue = blobInfo.blobUri().split("/").pop();

            const ext = blobInfo.filename().split(".").pop();

const uniqueName =
  Date.now() +
  "-" +
  Math.random().toString(36).substring(2, 8) +
  "." +
  ext;
                console.log(lastValue , "lalalalallala");
                
            formData.append("file", blobInfo.blob(), uniqueName);
            // formData.append('files[]', blobInfo.blob(), blobInfo.filename());
            return axios("https://api.tetr.com/api/upload/r2", {
              method: "POST",
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) =>  Promise.resolve(response.data.url + "?t=" + Date.now()  ));
           
          },
          toolbar:
            " styles " +
            " formatselect fontsizeselect   " +
            "bold italic underline | backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist | outdent indent " +
            "removeformat help " +
            " image " +
            " media " +
            "  " +
            "undo redo ",

          content_style:
            "body { font-family: Nunito Sans, sans-serif !important; line-height: 30px; font-size:20px;font-weight:200}; h1{font-weight:700}",
          font_formats:
            "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
          // visualblocks_default_state: true,
          setup: (editor) => {
            editor.on("change", () => {
              handleChange(editor.getContent());
            });

            // editor.ui.registry.addToggleButton("customImage", {
            //   icon: "upload",
            //   tooltip: "Custom Image",
            //   onAction: function (api) {
            //     filePickerCallback((base64, meta) => {
            //       editor.insertContent(
            //         `<img src="${base64}" alt="${meta.text}">`
            //       );
            //     });
            //   },
            // });
          },
        }}
      />
      {isError && <span className="FormError">{erroMessage}</span>}
    </>
  );
};

export default TinyEditor;
